<template>
	<div class="container-wrap cs_page">
		<customer-top currentTab="inquiry"></customer-top>
		<div class="container-box">
			<h3 class="title mb_20">{{ $t('cs.inquiry.inquiry') }}</h3>
			<form v-if="isWrite" class="q_write" autocomplete="off" @submit.prevent>
				<div class="input_box">
					<div class="label_text">Inquiry Type</div>
					<div class="select_wrap mb_10">
						<select class="contact_type" v-model="type_seq">
							<option value="" selected disabled>
								{{ $t('cs.placeholder.type') }}
							</option>
							<option
								v-for="item in ticket_type_list"
								:key="item.seq"
								:value="item.seq"
							>
								{{ item.title }}
							</option>
						</select>
					</div>
				</div>
				<div class="input_box">
					<div class="label_text">Title</div>
					<input
						type="text"
						:placeholder="$t('cs.placeholder.title')"
						class="mb_10"
						v-model="title"
					/>
				</div>
				<div class="input_box">
					<div class="label_text">Inquiry</div>
					<textarea
						class="ask"
						:placeholder="$t('cs.placeholder.content')"
						v-model="content"
					></textarea>
				</div>

				<div class="inquiry_button_area">
					<button class="button_primary">
						{{ $t('button.cancel') }}
					</button>
					<button class="button_bg_blue" @click="registTicket">
						{{ $t('button.confirm') }}
					</button>
				</div>
			</form>
			<div v-else class="inquiry_complete">
				<div class="complete_box">
					<div class="status_icon success"></div>
					<p class="mb_10">
						{{ $t('cs.inquiry.text1') }}<br />
						<span class="">{{ $t('cs.inquiry.text2') }}</span>
						{{ $t('cs.inquiry.text3') }}
					</p>
					<button class="button_bg_blue" @click="goList">
						{{ $t('button.inquiry_list') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import CustomerTop from '@/components/User/Cs/CustomerTop.vue';

export default {
	name: 'Inquiry',
	components: {
		CustomerTop,
	},
	data() {
		return {
			isWrite: true,
			parent_seq: 0,
			type_seq: '',
			title: '',
			content: '',
			email_address: '',
			password: '',
			field_values: [],
			ticket_type_list: [],
			ticket_id: '',
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticket_type_list = data;
		},
		async registTicket() {
			const params = {
				parent_seq: this.parent_seq,
				type_seq: this.type_seq,
				title: this.title,
				content: this.content,
				email_address: this.email_address,
				password: this.password,
				field_values: this.field_values,
			};
			await createTicket(params)
				.then(result => {
					this.ticket_id = result.ticket_id;
					this.isWrite = false;
				})
				.catch(commonError);
		},
		goList() {
			this.$router.push({ name: 'user-inquiry_list' });
		},
	},
};
</script>
